(function () {
    'use strict';
    angular.module('Services').factory('TransitWarrantyService', TransitWarrantyService);
    TransitWarrantyService.$inject = [
        'Request',
        '$filter',
        '$cookies',
        '$rootScope'
    ];

    function TransitWarrantyService(
        Request,
        $filter,
        $cookies,
        $rootScope
    ) {
        return {
            Rates: {
                create: function (successCallback, errorCallback, data) {
                    Request.post({
                        method: 'POST',
                        url: ApiURLs.transitWarranty.rates,
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, data);
                },
                getAll: function (successCallback, errorCallback, data) {
                    Request.get({
                        url: ApiURLs.transitWarranty.rates,
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: data
                    });
                },
                getDetails: function (successCallback, errorCallback, id) {
                    Request.get({
                        url: ApiURLs.transitWarranty.rateDetails.replace(':id', id),
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    });
                },
                update: function (successCallback, errorCallback, id, data) {
                    Request.post({
                        method: 'PUT',
                        url: ApiURLs.transitWarranty.rateDetails.replace(':id', id),
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, data);
                },
                delete: function (successCallback, errorCallback, id) {
                    Request.post({
                        method: 'DELETE',
                        url: ApiURLs.transitWarranty.rateDetails.replace(':id', id),
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    });
                },
                generateCreateRatePayload: function (data) {
                    let carrierProfiles = [];
                    let companies = [];
                    if (!data.carrierProfiles.find(prof => prof.name == 'All')) {
                        carrierProfiles = data.carrierProfiles.map(prof => prof.carrierProfileId ? prof.carrierProfileId : prof.id);
                    }

                    if (!data.companies.find(prof => prof.name == 'All')) {
                        companies = data.companies.map(prof => prof.companyId ? prof.companyId : prof.id);
                    }

                    if (data.companies.find(prof => prof.name == 'All')) {
                        companies = ['all']
                    }

                    return {
                        rateName: data.rateName,
                        carrierProfiles: carrierProfiles,
                        companies: companies,
                        coverageAmount: Number(data.coverageAmount),
                        coveragePercent: Number(data.coveragePercent),
                        ratePercent: Number(data.ratePercent),
                        excess: Number(data.excess),
                        margin: Number(data.margin),
                        marginPercent: Number(data.marginPercent),
                        providerId: data.warrantyProvider.id,
                        rate: Number(data.rate),
                        active: data.active || false
                    };
                }
            },
            Claims: {
                create: function (successCallback, errorCallback, data) {
                    Request.post({
                        method: 'POST',
                        url: ApiURLs.transitWarranty.claims,
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, data);
                },
                getAll: function (successCallback, errorCallback, data) {
                    Request.get({
                        url: ApiURLs.transitWarranty.claims,
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        data: data
                    });
                },
                getDetails: function (successCallback, errorCallback, id) {
                    Request.get({
                        url: ApiURLs.transitWarranty.rateDetails.replace(':id', id),
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    });
                },
                update: function (successCallback, errorCallback, id, data) {
                    const resellerId = $cookies.get('resellerId');
                    Request.post({
                        method: 'PUT',
                        url: ApiURLs.transitWarranty.claimDetails.replace(':id', id) + '?reseller_id=' + resellerId,
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    }, data);
                },
                delete: function (successCallback, errorCallback, id) {
                    Request.post({
                        method: 'POST',
                        url: ApiURLs.transitWarranty.claimDetails.replace(':id', id),
                        successCallback: successCallback,
                        errorCallback: errorCallback
                    });
                },
                uploadEvidence: function (successCallback, errorCallback, file) {
                    Request.upload({
                        url: ApiURLs.transitWarranty.claimUploadEvidence,
                        method: 'POST',
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                    }, file);
                },
                generateCreateClaimsPayload: function (data, rate, shipment) {
                    return {
                        warrantyRateId: rate.id,
                        shipmentId: shipment.shipmentId,
                        customerName: data.customerName,
                        declaredValue: Number(data.declaredValue),
                        reasonForClaim: data.reasonForClaim,
                        claimAmount: Number(data.claimAmount),
                        evidence: data.evidence,
                        notes: data.notes || null
                    }
                },
                generateUpdateClaimsPayload: function (data) {
                    return {
                        payoutDate: $filter('bbaDate')(data.payoutDate),
                        claimAmount: data.claimAmount,
                        evidence: data.evidence,
                        notes: data.notes,
                        reasonForClaim: data.reasonForClaim
                    }
                },
                report: function (successCallback, errorCallback, data, resellerId) {
                    Request.post({
                        method: 'POST',
                        url: `${ApiURLs.transitWarranty.report}?reseller_id=${resellerId}`,
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        disableResellerFilter: false,
                    }, data);
                },
                exportToPDF: function (successCallback, errorCallback, data) {
                    const fileName = data.startDate ? `${data.startDate}-${data.endDate}` : 'monthly';
                    Request.downloadFile({
                        fileName: `transit-warranty-report-${fileName}.pdf`,
                        method: 'POST',
                        url: ApiURLs.transitWarranty.reportExportPDF,
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        fileType: 'application/pdf',
                        responseType: 'arraybuffer',
                        data: data,
                        headers: {
                            Accept: 'application/pdf'
                        }
                    });
                },
                exportToCSV: function (successCallback, errorCallback, data) {
                    const fileName = data.startDate ? `${data.startDate}-${data.endDate}` : 'monthly';
                    Request.downloadFile({
                        fileName: `transit-warranty-report-${fileName}.csv`,
                        method: 'POST',
                        url: ApiURLs.transitWarranty.reportExportCSV,
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                        fileType: 'text/csv',
                        responseType: 'arraybuffer',
                        data: data,
                        headers: {
                            Accept: 'text/csv'
                        }
                    });
                }
            },
            providers: {
                getAll: function (successCallback, errorCallback) {
                    Request.get({
                        url: ApiURLs.transitWarranty.getProvider,
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                    });
                },
                getMappingProvider: function (successCallback, errorCallback) {
                    const id = $rootScope.GlobalProfile.company.id;
                    Request.get({
                        url: ApiURLs.transitWarranty.getProvidermapping.replace(':id', id),
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                    });
                },
                updateStatus: function (id, successCallback, errorCallback, data) {
                    Request.post({
                        method: 'POST',
                        url: ApiURLs.transitWarranty.getProvidermapping.replace(':id', id),
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                    }, data);
                },
                createNewProvider: function (successCallback, errorCallback, data) {
                    Request.post({
                        method: 'POST',
                        url: ApiURLs.transitWarranty.createNewProvider,
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                    }, data);
                },
                updateProvider: function (successCallback, errorCallback, data) {
                    Request.post({
                        method: 'PUT',
                        url: ApiURLs.transitWarranty.createNewProvider,
                        successCallback: successCallback,
                        errorCallback: errorCallback,
                    }, data);
                },
            }

        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/TransitWarrantyService.js